import React from "react";

import { useDateRender } from "./useDateRender";

type DateTimeDisplayProps = {
    date: string | Date;
};

export const DateTimeDisplay = ({ date }: DateTimeDisplayProps): JSX.Element => {
    const { renderDateTime } = useDateRender();

    return <>{renderDateTime(new Date(date))}</>;
};
